<template>
  <div id="registrationShareEmailLink" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->
      <div class="modal-content custom-email-share-link">
        <div class="modal-header">
          <section>
            <div class="col-xs-12 p-16 d-flex align-items-center justify-content-between header-wrapper">
              <div class="modal-header-title fw-600 font-20">{{ $t('shareLink') }}</div>
              <img class="pr-5 cursor-pointer" src="/static/images/icons/emergo_modal_close.svg" @click="closePopup" />
            </div>
          </section>
        </div>
        <div class="modal-body p-0">
          <div class="col-md-12 field-container">
            <div class="col-md-12 field-name fw-400 p-0">{{ $t('subject') }}:</div>
            <div class="col-md-12" style="padding: 0;">
              <input type="text" class="share-link-form-control" v-model="emailSubject" />
            </div>
          </div>
          <div class="col-md-12 field-container">
            <div class="col-md-12 field-name fw-400 p-0">
              {{ $t('To') }}:
              <span style="color: #B00505;">*</span>
            </div>
            <div class="col-md-12 p-0" style="padding: 0;" v-if="meta.mode != '3'">
              <!-- <input type="text" class="form-control" placeholder="Enter one or more email addresses"> -->
              <v-select
                :options="ramsUserList"
                multiple
                allowToAddItem
                :searchable="true"
                v-model="selectedUsers"
                style="width: 100%"
                :close-on-select="true"
                label="userName"
                :autocomplete="true"
                :placeholder="placeValue"
              >
                <!-- <template slot="option" slot-scope="option">
                  <div>{{option.userName}}</div>
                </template> -->
              </v-select>
            </div>
            <div class="col-md-10" style="padding: 0;" v-else>
              <input type="text" v-model="emergoEmail" class="share-link-form-control" disabled />
            </div>
          </div>

          <div class="col-md-12 field-container">
            <div class="col-md-12 field-name fw-400 p-0">{{ $t('note') }}:</div>
            <div class="col-md-12" style="padding: 0;">
              <textarea class="share-link-note-field" v-model="emailNote"></textarea>
            </div>
          </div>

          <div class="col-md-12 field-container" v-if="meta.isLink">
            <div class="col-md-12 field-name fw-400 p-0">{{ $t('contents') }}:</div>
            <div class="col-md-12" style="padding: 0;">
              <div class="share-link-content-field">
                {{ $t('contentsNote') }}:
                <br />
                <a target="_blank" href="layout/registration">{{ registrationLink }}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="clear: both;">
          <div class="col-xs-12 p-0 d-flex align-items-center justify-content-end col-gap-16">
            <button type="button" class="cancel-btn btn emergo-btn emergo-secondary-button" @click="closePopupOnCancel">
              {{ $t('cancel') }}
            </button>

            <button
              type="button"
              class="send-btn btn emergo-btn emergo-primary-button"
              @click="sendEmail"
              :disabled="disableSubmit"
            >
              {{ $t('send') }}
            </button>
          </div>
        </div>
      </div>
      <loader :loadingStatus="loaderStatus"></loader>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import Loader from '../UIComponents/Loader.vue';
import vSelect from '../UIComponents/Select.vue';
import { sendDetailsByEmail } from '../../apis/email';
import { getUserList } from '../../apis/profile';

export default {
  components: {
    Loader,
    vSelect
  },
  props: {
    data: Object,
    meta: Object,
    relatedCertificates: Array
  },
  data() {
    return {
      emergoEmail: '',
      emailSubject: '',
      selectedUsers: [],
      ramsUserList: [],
      registrationLink: '',
      errors: [],
      loaderStatus: false,
      placeValue:
        this.$i18n.locale === 'English' ? 'Enter one or more email addresses' : 'Insira um ou mais endereços de e-mail',
      disableSubmit: true,
      emailNote: ''
    };
  },
  methods: {
    closePopup() {
      $('#registrationShareEmailLink').modal('hide');
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    async sendEmail() {
      this.loaderStatus = true;
      const shareEmailObj = {};
      shareEmailObj.certOrReg = 1;
      shareEmailObj.certOrRegId = this.meta.id;

      shareEmailObj.mailSubject = this.emailSubject;
      shareEmailObj.sendToOption = 1;

      if (this.meta.mode === '3') {
        shareEmailObj.mode = 'emergo';
        shareEmailObj.mailSendToList = [{ emailId: this.emergoEmail }];
      } else {
        shareEmailObj.mailSendToList = this.selectedUsers;
      }
      shareEmailObj.mailNotes = this.emailNote;
      shareEmailObj.isSendLinkOnly = this.meta.isLink;

      const result = await sendDetailsByEmail(shareEmailObj);
      this.loaderStatus = false;
      if (result) {
        this.clearNotifcations();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: this.$i18n.locale === 'English' ? 'Email sent successfully!' : 'E-mail enviado com sucesso!',
          group: 'custom-notification'
        });
        this.closePopupOnCancel();
      } else {
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: 'Unable to sent email!',
          group: 'custom-notification'
        });
      }
    },
    closePopupOnCancel() {
      this.selectedUsers = [];
      this.emailSubject = '';
      this.emailNote = '';
      $('#registrationShareEmailLink').modal('hide');
      this.$emit('deleteMetaData');
    },
    async initialAPICallsShareLink() {
      this.loaderStatus = true;
      this.ramsUserList = await getUserList();
      this.loaderStatus = false;
    },
  },
  watch: {
    meta() {
      if (this.meta.isLink) {
        const currentURLParts = window.location.href.split('/');
        currentURLParts.splice(currentURLParts.length - 1, 1);
        this.registrationLink = `${currentURLParts.join('/')}/email/1/${this.meta.id}`;
      }
      if (this.meta.mode === '3') {
        this.emailSubject = 'Seeking support with registration renewal';
      } else if (this.meta.isLink) {
        this.emailSubject =
          this.$i18n.locale === 'English'
            ? 'Conformity Declaration Management Registration Link'
            : 'Conformity Declaration Management Link de Cadastro';
      } else {
        this.emailSubject = 'Conformity Declaration Management Registration Details';
      }
    },
    selectedUsers() {
      if (this.selectedUsers.length) {
        this.disableSubmit = false;
        this.placeValue = '';
      } else {
        this.disableSubmit = true;
        this.placeValue =
          this.$i18n.locale === 'English'
            ? 'Enter one or more email addresses'
            : 'Insira um ou mais endereços de e-mail';
      }
    },
    emergoEmail() {
      if (this.emergoEmail) {
        this.disableSubmit = false;
        this.placeValue = '';
      } else {
        this.disableSubmit = true;
        this.placeValue =
          this.$i18n.locale === 'English'
            ? 'Enter one or more email addresses'
            : 'Insira um ou mais endereços de e-mail';
      }
    }
  },
  mounted() {
    $('#registrationShareEmailLink').on('shown.bs.modal', this.initialAPICallsShareLink);
  }
};
</script>
<style scoped>
.header-wrapper {
  border-bottom: 1px solid #d3d3d3;
  margin-bottom: 24px;
}

.pl-32 {
  padding-left: 32px;
}
.modal-dialog {
  border-radius: 8px !important;
}
.custom-email-share-link.modal-content {
  background: #ffffff;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%) !important;
  border-radius: 8px !important;
}
.custom-email-share-link .modal-header {
  background: #ffffff !important;
  border-bottom: none !important;
  padding: 0px !important;
  border-radius: 8px;
  color: #1a1a1a;
}
.custom-email-share-link .modal-footer {
  border-radius: 8px;
  background: #fafaf9;
  border-top: none !important;
  padding: 16px;
}

.modal-header-title {
  line-height: 27px;
  color: #1a1a1a;
}

.field-name {
  font-size: 16px;
  line-height: 22px;
  color: #3e3e3e;
  margin-bottom: 7px;
}

.modal-body .field-container {
  padding: 0px 32px 40px 32px;
}
.custom-email-share-link .share-link-form-control {
  width: 100%;
  font-weight: 400;
  font-size: 16px;
  height: 44px;
  line-height: 25px !important;
  color: #4d4d4d;
  background: #ffffff;
  border: 1px solid #4d4d4d;
  border-radius: 3px;
  padding: 10px 0px 9px 12px;
}
.custom-email-share-link .share-link-form-control:focus {
  outline: none;
}
.custom-email-share-link .share-link-note-field,
.custom-email-share-link .share-link-content-field {
  width: 100%;
  padding: 12px 0px 32px 12px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #4D4D4D;
  background: #ffffff;
  border: 1px solid #4D4D4D;
  border-radius: 3px;
}
.custom-email-share-link .share-link-note-field:focus {
  outline: none;
}
.custom-email-share-link .share-link-content-field,
.custom-email-share-link .share-link-content-field a,
.custom-email-share-link .share-link-content-field a:hover {
  color: #4d4d4d !important;
}
/* .custom-email-share-link .cancel-btn,
.custom-email-share-link .cancel-btn:focus,
.custom-email-share-link .cancel-btn:hover{
  padding: 10px 33px 9px 31px;
  border: 1px solid #000000;
  border-radius: 5px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #000000 !important;
  background-color: transparent;
} */
/* .custom-email-share-link .send-btn,
.custom-email-share-link .send-btn:focus,
.custom-email-share-link .send-btn:hover{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  background-color: #01518a;
  border: none;
  cursor: pointer;
  color: #ffffff;
  border-radius: 5px;
  padding: 10px 40px 9px 39px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
} */
/* .custom-email-share-link .send-btn[disabled] {
  opacity: 0.4;
  cursor:not-allowed;
} */
body {
  padding-right: 0px !important;
}
.custom-email-share-link .share-link-mail-body {
  height: 200px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
}
#registrationShareEmailLink .email-reg-share-heading {
  position: absolute;
  padding-top: 8px;
  padding-left: 7px;
}
#registrationShareEmailLink .email-icon {
  font-size: 40px;
  margin-left: 9px;
}
::v-deep .v-select .dropdown-menu {
  width: 100% !important;
}
::v-deep .v-select .selected-tag {
  white-space: nowrap !important;
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  margin-top: 6px;
}
/* #registrationShareEmailLink .v-select .selected-tag:nth-child(-n+3){
  margin-top: 0px;
} */
::v-deep .v-select .dropdown-toggle {
  background-image: none;
  padding: 0px;
  color: #4d4d4d;
  background: #ffffff;
  border: 1px solid #4d4d4d;
  border-radius: 3px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
}
::v-deep .v-select .dropdown-toggle input {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #4D4D4D;
  line-height: 25px;
}

::v-deep .v-select .dropdown-toggle input::placeholder {
  color: #999999;
  font-weight: 400;
}
::v-deep .v-select input {
  height: 44px;
  width: 100% !important;
  padding: 10px 0px 9px 12px !important;
}
::v-deep .v-select input[type='search'] {
  padding-left: 0px;
  padding-right: 0px;
}
::v-deep .v-select .open-indicator {
  left: unset;
  right: 10px;
}
::v-deep .v-select .open-indicator {
  display: none !important;
}
::v-deep .v-select input[type='search']::placeholder {
  color: #999999 !important;
  font-weight: 400;
}
::v-deep .v-select li > a {
  padding: 2px 7px;
}
@media (min-width: 992px) {
  .modal-lg {
    width: 720px !important;
  }
}
@media (min-width: 768px) {
  ::v-deep .v-select input {
    width: 300px !important;
  }
}
@media (min-width: 600px) and (max-width: 992px) {
  ::v-deep .v-select input[type='search'] {
    font-size: 11px;
  }
}
</style>
